export function deepLoopObjectAndTransformStringProperties(obj, transformFn) {
  const isObject = val => val && typeof val === 'object' && !Array.isArray(val);
  const recursiveLoop = currentObj => {
    if (Array.isArray(currentObj)) {
      return currentObj.map(item => {
        if (typeof item === 'string') {
          return transformFn(item);
        } else if (isObject(item) || Array.isArray(item)) {
          return recursiveLoop(item);
        } else {
          return item;
        }
      });
    } else {
      const newObj = {};
      for (const key in currentObj) {
        if (currentObj.hasOwnProperty(key)) {
          const value = currentObj[key];
          if (typeof value === 'string') {
            newObj[key] = transformFn(value);
          } else if (isObject(value) || Array.isArray(value)) {
            newObj[key] = recursiveLoop(value);
          } else {
            newObj[key] = value;
          }
        }
      }
      return newObj;
    }
  };
  return recursiveLoop(obj);
}
//# sourceMappingURL=utils.js.map